<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on }">
      <v-btn color="navbar" round class="hidden-sm-and-down" v-on="on">
        <v-icon medium class="mr-1">admin_panel_settings</v-icon>
        <div style="text-align: left">{{$t('Button.SystemAdministration')}}</div>
      </v-btn>
      <v-btn color="navbar" icon class="hidden-md-and-up" v-on="on">
        <v-icon medium>admin_panel_settings</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list dense dark>
        <v-subheader>Manage Access</v-subheader>
        <v-list-tile v-for="item in user" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-subheader>Manage Data</v-subheader>
        <v-list-tile v-for="item in mediaType" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-for="item in guideline" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-subheader>Manage Services</v-subheader>
        <v-list-tile v-for="item in services" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-subheader>Ingestion Management</v-subheader>
        <v-list-tile v-for="item in ingestion" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-subheader>Logs</v-subheader>
        <v-list-tile v-for="item in logs" :key="item.title" active-class="activeLink" :to="item.router">
          <v-list-tile-avatar>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>       
        
        <template v-if="adminPlugins.length > 0">
          <v-subheader>Manage Other</v-subheader>
          <v-list-tile v-for="plugin in adminPlugins" :to="{
              name: 'adminPlugins',
              params: { serviceLink: plugin.service.serviceLink, interfaceType: PLUGIN_INTERFACE_TYPES.SYS_ADMIN }
            }" :key="plugin.service.serviceLink" active-class="activeLink">
            <v-list-tile-avatar>
              <v-icon>{{ plugin.interfaces[PLUGIN_INTERFACE_TYPES.SYS_ADMIN].icon }}</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ plugin.interfaces[PLUGIN_INTERFACE_TYPES.SYS_ADMIN].linkName }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    PLUGIN_INTERFACE_TYPES,
  } from '@/store/ServiceRegistry/plugin'

  import {
    SERVICE_LINKS,
  } from '@/store/ServiceRegistry/linkedservices'

  const authenticate = createNamespacedHelpers('authenticate')
  const plugin = createNamespacedHelpers('plugin')

  export default {
    data() {
      return {
        PLUGIN_INTERFACE_TYPES,
        user: [{
          icon: 'account_circle',
          title: 'Users',
          router: {
            name: 'usermanage',
          },
        },
        {
          icon: 'group_work',
          title: 'Tenants',
          router: {
            name: 'accessManage',
          },
        },
        ],
        guideline: [{
          icon: 'rule',
          title: 'Guidelines',
          router: {
            name: 'guidelinesManage',
          },
        },
        {
          icon: 'emoji_symbols',
          title: 'Units',
          router: {
            name: 'unitsmanage',
          },
        },
        ],
        mediaType: [{
          icon: 'dns',
          title: 'Media Types',
          router: {
            name: 'mediaTypeManage',
          },
        },
        {
          icon: 'category',
          title: 'Station Categories',
          router: {
            name: 'stationcategorymanage',
          },
        },
        {
          icon: 'mdi-clock',
          title: 'Time Series Tags',
          router: {
            name: 'timeseriestagsmanage',
          },
        },        
        {
          icon: 'dns',
          title: 'Continuous Data Importers',
          router: {
            name: 'dataimportermanage',
          },
        },
        {
          icon: 'router',
          title: 'Aquarius Stations',
          router: {
            name: 'manageaquariusstations',
          },
        },
        ],
        services: [{
          icon: 'electrical_services',
          title: 'Services',
          router: {
            name: 'manageservices',
          },
        },
        // {
        //   icon: 'group_work',
        //   title: 'Service Credentials',
        //   router: {
        //     name: 'manageservicecredentials',
        //   },
        // },
        ],
        ingestion: [{
          icon: 'cloud_sync',
          title: 'CDI Dashboard',
          router: { name: 'ingestionDashboard' },
        },
        // {
        //   icon: 'settings',
        //   title: 'Configurations',
        //   router: { name: 'ingestionConfigs' },
        // },
        // {
        //   icon: 'schedule',
        //   title: 'Schedules',
        //   router: { name: 'ingestionSchedules' },
        // },
        // {
        //   icon: 'history',
        //   title: 'Job Runs',
        //   router: { name: 'ingestionJobs' },
        // },
        {
          icon: 'add_a_photo',
          title: 'Photo Upload',
          router: { name: 'ingestionPhotoUpload' },
        }],
        logs: [{
          icon: 'menu_book',
          title: 'Continuous data API logs',
          router: {
            name: 'aquariusLogs',
          },
        }],
        
      }
    },
    computed: {
      adminPlugins() {
        return this.activePlugins.filter(plugin => {
          if (plugin.interfaces[PLUGIN_INTERFACE_TYPES.SYS_ADMIN]) {
            if (plugin.service.serviceLink === SERVICE_LINKS.EQUIPMENT_TRACKER) {
              // temp: only show equipment menu for EQUIPMENT_TRACKER tenant users
              return this.currentTenant.name === 'EQUIPMENT_TRACKER'
            }
            return true
          }
          return false
        })
      },
      ...authenticate.mapGetters(['currentTenant']),
      ...plugin.mapState(['activePlugins']),
    },
    async mounted() {},
    methods: {},
  }
</script>